<script setup lang="ts">
import { ref, toRefs, onMounted } from 'vue';
import Dialog from 'primevue/dialog';
import Calendar from 'primevue/calendar';
import { EMIT, PERMISSIONS } from '@/enum';
import { useOverageStore } from '@/store';
import { can } from '@/composables';

import SeatsPerDiscipline from './SeatsPerDiscipline.vue';
interface Props {
  organizationId: number;
}

const props = defineProps<Props>();
const { organizationId } = toRefs(props);

const emit = defineEmits<{
  (e: EMIT.CANCEL): void;
}>();

const overageStore = useOverageStore();

const modalVisible = ref<boolean>(true);
const month = ref<Date>(new Date());

const cancel = (): void => {
  emit(EMIT.CANCEL);
  modalVisible.value = false;
};

const getOverages = async () => {
  if (can([PERMISSIONS.OVERAGES_LIST])) {
    overageStore.loading.modal = true;
    await overageStore.getOrganizationOverages(organizationId.value, month.value, false);
    overageStore.loading.modal = false;
  }
};

onMounted(async () => {
  await getOverages();
});
</script>

<template>
  <Dialog v-model:visible="modalVisible" :draggable="false" :modal="true" class="dialog__container" @hide="cancel">
    <template #header>
      <div class="dialog__header flex flex-column">
        <h2 class="mb-3">Seats in Use</h2>
        <div>
          <Calendar
            v-model="month"
            view="month"
            date-format="MM"
            :show-icon="true"
            :manual-input="false"
            icon-display="input"
            @date-select="getOverages"
          />
        </div>
      </div>
    </template>
    <Loader v-if="overageStore.loading.modal" class="flex justify-content-center align-items-center h-full loader" />
    <div v-if="overageStore.overage_list.length" class="py-3">
      <SeatsPerDiscipline v-for="(overage, index) in overageStore.overage_list" :key="index" :overage="overage" />
    </div>
    <div v-else>
      <div class="no-services alert-red font-semibold bg-white align-content-center text-center">
        No applicable services for this month
      </div>
    </div>
  </Dialog>
</template>

<style scoped lang="scss">
.no-services {
  min-height: 50px;
}
</style>
